import { createFileRoute } from "@tanstack/react-router";
import TravertinePavers from "@/pages/TravertinePavers";
import { buildHead } from "@/lib/seo";

export const Route = createFileRoute("/travertine-pavers")({
  head: () =>
    buildHead({
      title:
        "Premium Travertine Pavers for Pool Decks & Patios | Precision Pavers & Pool Design",
      description:
        "Explore our exclusive collection of premium natural travertine pavers for pool decks, patios, driveways, and outdoor living spaces in South Florida. Free estimates.",
      path: "/travertine-pavers",
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "Product",
          name: "Premium Travertine Pavers Collection",
          description:
            "Natural stone travertine pavers in various shades, sizes, and textures for luxury pool deck and patio installations.",
          brand: {
            "@type": "Brand",
            name: "Precision Pavers & Pool Design",
          },
          offers: {
            "@type": "AggregateOffer",
            priceCurrency: "USD",
            availability: "https://schema.org/InStock",
          },
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://precisionpaverspools.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Travertine Pavers",
              item: "https://precisionpaverspools.com/travertine-pavers",
            },
          ],
        },
      ],
    }),
  component: TravertinePavers,
});
